module.exports = __webpack_public_path__ + "static/media/hos_2_filter.a76e02c9.png";